import { Color } from '@nicolaudie-group/ls-utilities'
import config from '@/config'
import useProfileStore, { constantsKey } from '@/stores/profile.store'
import pinia from '@/stores/pinia'
import * as find from './find'

export { default as canHavePresets } from '@/helpers/profile/canHavePresets'

/**
 * Gets the constants from the profile store
 * @returns {Object} - Channels constants from the profile store
 */
function getConstants() {
  const profileStore = useProfileStore(pinia)
  const constants = profileStore[constantsKey]
  return constants ? constants.channels : null
}

const iconsLocation = config.assetsLocations.icons
const BLACK = 0x000000 // Black color in decimal format (0xBBGGRR)

/**
 * Get the global channel linked to the provided local channel
 * @param {Array} searchIn - List in which to search for the global channel
 * @param {Channel} localChannel - Local channel for which to get the global channel
 * @returns {Channel}
 */
export const getLinkedChannel = (searchIn, localChannel) => {
  if (localChannel && localChannel._linkedChannel) {
    return find.item(searchIn, localChannel._linkedChannel)
  }
  return null
}

/**
 * Returns true of the provided channel is a EXTRA_COLOR channel
 * @param {Channel} channel - Channel to test if EXTRA_COLOR channel
 * @returns {Boolean} Wether the channel is a EXTRA COLOR channel or not
 */
const isExtraColor = (channel) => {
  const channelConstants = getConstants()
  return (
    channel
    && channelConstants
    && channel.channel_type === channelConstants.types.SSL_CH_EXTRA_COLOR
  )
}

/**
 * Get the path of the icon of a channel, or it's colors if applicable
 * @param {Preset} preset - Channel for which to get the icon
 * @returns {String} Path of the icon
 */
export const getIcon = (channel) => {
  if (isExtraColor(channel)) {
    // If this is a "extra color" channel, we show it's color(s) instead of the icon
    // Get the min/max colors and try parsing them
    const min = new Color(channel.color_min)
    const max = new Color(channel.color_max)
    const colors = []
    // We then check if the min/max colors are valid, and if so add them
    // to the array of colors to display in the icon
    // We also ignore them if they're black, since it makes more sense for an extra-color channel
    if (max.isValid && max.dec !== BLACK) {
      colors.push(max)
    }
    if (min.isValid && min.dec !== BLACK) {
      colors.push(min)
    }
    // Show the colors only if there is at least one, otherwise show the icon for the channel
    if (colors.length) {
      return colors
    }
  }
  // if the icon is falsy, use the UNDEF icon
  let iconName = channel?._icon || 'Undef_Undef.png'
  // if the icon is 'noIcon', use the UNDEF icon
  iconName = iconName.toLowerCase() === 'noicon' ? 'Undef_Undef.png' : iconName
  // If this is any other kind of preset, show the preset asset
  return `${iconsLocation.channels}/${iconName}`
}
